/**
 * VIORI Blog — GA4 event tracking
 * Fires scroll_depth events at 25/50/75/100, time-on-page marks and a page-level blog_view event.
 * Oct 2026 fix: this file loads in <head>, before <body> exists, so the old
 * document.body check threw an error and no blog events fired. It now waits
 * for the page to be parsed.
 */
(function() {
  if (typeof window.gtag !== 'function') {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function() { dataLayer.push(arguments); };
  }

  function start() {
    // Only fire on blog article pages
    var isArticle = (document.body && document.body.classList.contains('template-article')) ||
                    (window.Shopify && window.Shopify.template === 'article');
    if (!isArticle) return;

    var postMeta = {
      post_slug: window.BLOG_POST_META ? window.BLOG_POST_META.handle : (location.pathname.split('/').pop() || ''),
      post_theme: window.BLOG_POST_META ? window.BLOG_POST_META.theme : '',
      post_topic: window.BLOG_POST_META ? window.BLOG_POST_META.topic : ''
    };

    gtag('event', 'blog_view', postMeta);

    var marks = [25, 50, 75, 100];
    var fired = {};
    function onScroll() {
      var h = document.documentElement;
      var pct = Math.round((h.scrollTop + window.innerHeight) / h.scrollHeight * 100);
      marks.forEach(function(m) {
        if (pct >= m && !fired[m]) {
          fired[m] = true;
          gtag('event', 'scroll_depth', Object.assign({ percent: m }, postMeta));
        }
      });
      if (fired[100]) window.removeEventListener('scroll', onScroll);
    }
    window.addEventListener('scroll', onScroll, { passive: true });

    var timeMarks = [30, 60, 120, 300];
    timeMarks.forEach(function(s) {
      setTimeout(function() {
        gtag('event', 'blog_time_on_page', Object.assign({ seconds: s }, postMeta));
      }, s * 1000);
    });

    // Mark CTA engagement in sessionStorage (session frequency cap)
    var ctaEvents = ['quiz_start', 'product_card_click', 'quick_add_click', 'email_capture', 'sms_capture'];
    var originalGtag = window.gtag;
    window.gtag = function() {
      if (arguments[0] === 'event' && ctaEvents.indexOf(arguments[1]) !== -1) {
        try { sessionStorage.setItem('viori_cta_engaged_session', 'true'); } catch(e) {}
      }
      return originalGtag.apply(this, arguments);
    };
  }

  if (document.body) { start(); } else { document.addEventListener('DOMContentLoaded', start); }
})();
